import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { UrlHelper } from '../../utils/UrlHelper';

export class HelpFaqTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.HELP;

    public render(): JSX.Element {
        return (
            <div className={this.getCSSClass()}>
                {this.header()}
                <div className="hamburger-tab-content" style={{padding: 0}}>
                    <iframe src={UrlHelper.getIFrameHelpLink(this.props.userLanguage)} className="popup-iframe"/>
                </div>
            </div>
        );
    }

    protected getLabel(): string {
        return t('FAQ');
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HelpFaqTab.tsx